import { render, staticRenderFns } from "./TotalClientsCard.vue?vue&type=template&id=77acf8be&scoped=true"
import script from "./TotalClientsCard.vue?vue&type=script&lang=js"
export * from "./TotalClientsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77acf8be",
  null
  
)

export default component.exports